import { SettingsInterface } from 'client/Interfaces/Settings/SettingsInterface'
import { SubscriptionInterface, SubscriptionPlanInterface } from 'client/Interfaces/Subscription'
import { ISubscriptionFeatureList } from 'client/Interfaces/Subscription/ISubscriptionFeatureList'

export enum IAvailablePlanNames {
  'plan.none' = 'plan.none',
  'plan.free' = 'plan.free',
  'plan.ageras_free' = 'plan.ageras_free',
  'plan.starter' = 'plan.starter',
  'plan.ageras_start' = 'plan.ageras_start',
  'plan.pro' = 'plan.pro',
  'plan.ageras_basic' = 'plan.ageras_basic',
  'plan.growth' = 'plan.growth',
  'plan.ageras_plus' = 'plan.ageras_plus',
  'plan.merchant' = 'plan.merchant',
  'plan.contact_us' = 'plan.contact_us',
}

export enum SubscriptionType {
  SUBSCRIBE,
  UPGRADE,
  DOWNGRADE,
  CHANGE_TO_MONTHLY_UPGRADE,
  CHANGE_TO_MONTHLY_CURRENT,
  CHANGE_TO_MONTHLY_DOWNGRADE,

  CHANGE_TO_YEARLY_UPGRADE,
  CHANGE_TO_YEARLY_CURRENT,
  CHANGE_TO_YEARLY_DOWNGRADE,

  CURRENT,
  CURRENT_FREE,
}

// PremiumPlanCollection
export interface ISubscriptionPremiumPlanCollectionPropsInterface {
  plans: SubscriptionPlanInterface[]
  currentSubscription: SubscriptionInterface
  hideDowngradePlans: boolean
  dateFormat: string
  locale: string
  allPlans: SubscriptionPlanInterface[]
  onCancelDowngrade: () => void
  onPlanSelection: (plan: SubscriptionPlanInterface, cancelationFlow?: boolean, isDowngrade?: boolean) => Promise<void>
  settings: SettingsInterface
}

// PremiumPlanOptions
type ISubscriptionPremiumPlanOptionPropsInterface = Omit<ISubscriptionPremiumPlanCollectionPropsInterface, 'plans'>
export interface ISubscriptionPremiumPlanOptionsPropsInterface extends ISubscriptionPremiumPlanOptionPropsInterface {
  plan: SubscriptionPlanInterface
  allPlans: SubscriptionPlanInterface[]
  premiumPlansFeatures: TPremiumPlansFeatures
  selectableAvailablePlans?: Array<Record<string, unknown>>
  selectedPlanName: string
  isCombinedPlan: boolean
  onSelectCombinedPlan?: (planName: any) => void
}

// PremiumPlanOptionsCombined
type TSubscriptionPremiumPlanOptionCombinedPropsInterface = Omit<
  ISubscriptionPremiumPlanOptionsPropsInterface,
  'plan' | 'selectedPlanName' | 'selectableAvailablePlans' | 'isCombinedPlan' | 'currentSubscription'
>
export interface ISubscriptionPremiumPlanOptionsCombinedPropsInterface
  extends TSubscriptionPremiumPlanOptionCombinedPropsInterface {
  allPlans: SubscriptionPlanInterface[]
  groupedPlans: SubscriptionPlanInterface[]
  subscription: SubscriptionInterface
  planFilters: any
  isCombinedPlan?: boolean
}

export type TPremiumPlansFeatures = {
  [key in SubscriptionPlanInterface['name']]: Omit<ISubscriptionFeatureList, 'billingCycle'>
}
